
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.932 24A3.937 3.937 0 010 20.068v-7.136A3.937 3.937 0 013.932 9h16.136A3.937 3.937 0 0124 12.932v7.136A3.937 3.937 0 0120.068 24H3.932zm16.136-1.5a2.435 2.435 0 002.432-2.432v-1.223a2.976 2.976 0 00-1.865.117 2.995 2.995 0 00-1.787 3.537h1.22zm-2.75 0a4.514 4.514 0 01.295-2.522 4.498 4.498 0 014.888-2.665v-4.382a2.435 2.435 0 00-2.432-2.432H3.932A2.435 2.435 0 001.5 12.931v4.382a4.497 4.497 0 014.887 2.664c.338.79.439 1.67.295 2.522h10.636zM1.5 20.068A2.435 2.435 0 003.932 22.5h1.219a2.988 2.988 0 00-.143-1.932 2.982 2.982 0 00-1.644-1.605 2.962 2.962 0 00-1.865-.117v1.222z"}}),_c('path',{attrs:{"d":"M8.25 16.5a.75.75 0 01-.75-.75V15H5.25a.75.75 0 010-1.5h13.5a.75.75 0 010 1.5H9v.75a.75.75 0 01-.75.75zM15.75 7.5a.75.75 0 01-.75-.75V4.5c0-1.654-1.346-3-3-3s-3 1.346-3 3v2.25a.75.75 0 01-1.5 0V4.5C7.5 2.019 9.519 0 12 0s4.5 2.019 4.5 4.5v2.25a.75.75 0 01-.75.75z"}})])
          )
        }
      }
    